import {
  VENUES_TAXONOMY_KEY,
  BAR_SERVICES_TAXONOMY_KEY,
  BANDS_DJS_TAXONOMY_KEY,
  CAKES_DESSERTS_TAXONOMY_KEY,
  CATERING_TAXONOMY_KEY,
  FLORISTS_TAXONOMY_KEY,
  HAIR_MAKEUP_TAXONOMY_KEY,
  PHOTOGRAPHERS_TAXONOMY_KEY,
  VIDEOGRAPHERS_TAXONOMY_KEY,
  PLANNERS_TAXONOMY_KEY,
  SearchableVendorTaxonomyKey,
  VendorTaxonomyKey,
  SEARCHABLE_VENDOR_TAXONOMY_KEYS,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorWordPill } from '@zola-helpers/client/dist/es/marketplace/vendorWords';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { Title2 } from '@zola/zola-ui/src/typography/Headings';

import cx from 'classnames';

import { vendorCategoryLandingUrl } from '~/util/vendorSearchUrl';

import VendorIcon from '../common/icons/VendorIcon';

import styles from './vendorsByCategory.module.less';

export const ORDERED_VENDOR_CATEGORY_KEYS: SearchableVendorTaxonomyKey[] = [
  VENUES_TAXONOMY_KEY,
  PHOTOGRAPHERS_TAXONOMY_KEY,
  VIDEOGRAPHERS_TAXONOMY_KEY,
  FLORISTS_TAXONOMY_KEY,
  HAIR_MAKEUP_TAXONOMY_KEY,
  PLANNERS_TAXONOMY_KEY,
  BANDS_DJS_TAXONOMY_KEY,
  CATERING_TAXONOMY_KEY,
  CAKES_DESSERTS_TAXONOMY_KEY,
  BAR_SERVICES_TAXONOMY_KEY,
];

interface VendorsByCategoryProps {
  className?: string;
  excludeCategoryByType?: VendorTaxonomyKey;
  showHed?: boolean;
}

type VendorsCategoryListProps = React.HTMLAttributes<HTMLDivElement> & {
  categories?: SearchableVendorTaxonomyKey[];
  openInNewTab?: boolean;
  onLinkClick?: () => void | null;
};

export const VendorsCategoryList = ({
  categories = SEARCHABLE_VENDOR_TAXONOMY_KEYS,
  className,
  openInNewTab = false,
  onLinkClick = () => null,
  ...rest
}: VendorsCategoryListProps): JSX.Element => {
  const linkProps = openInNewTab
    ? {
        target: '_blank',
      }
    : {};
  return (
    <div className={cx(styles.categories, className)} {...rest} data-testid="category-links">
      {categories.map((vendorTaxonomyKey) => {
        const url = vendorCategoryLandingUrl(vendorTaxonomyKey);
        const name = getVendorWordPill(vendorTaxonomyKey);
        return (
          <LinkV2
            className={styles.category}
            key={`explore-by-category-${vendorTaxonomyKey}`}
            href={url}
            subtle
            noUnderline
            noTextTransform
            data-testid="category-link"
            onClick={onLinkClick}
            {...linkProps}
          >
            <VendorIcon className={styles.icon} vendorTaxonomyKey={vendorTaxonomyKey} size={64} />
            {name}
          </LinkV2>
        );
      })}
    </div>
  );
};

export const VendorsByCategory = ({
  className,
  excludeCategoryByType,
  showHed = true,
}: VendorsByCategoryProps) => {
  const filteredCategories = ORDERED_VENDOR_CATEGORY_KEYS.filter(
    (vendorTaxonomyKey) => excludeCategoryByType !== vendorTaxonomyKey
  );

  return (
    <div className={cx(styles.vendorsByCategory, className)}>
      {showHed && (
        <Title2 className={styles.hed} presentation="h3">
          Explore wedding vendors by category
        </Title2>
      )}
      <VendorsCategoryList categories={filteredCategories} />
    </div>
  );
};

export default VendorsByCategory;
